module.exports = __webpack_public_path__ + "img/storage-360-logo.6fccce26.svg";